var React = require('react');

function IconFailCircleO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M957.3 508.9c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.2 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.5-381-381z","key":0}),React.createElement("path",{"d":"M472.1 256h80c5.5 0 10 4.5 10 10v300.1c0 5.5-4.5 10-10 10h-80c-5.5 0-10-4.5-10-10V266c0-5.5 4.5-10 10-10z","key":1}),React.createElement("circle",{"cx":"514.6","cy":"701.5","r":"61.5","key":2})]);
}

IconFailCircleO.displayName = "IconFailCircleO";

IconFailCircleO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconFailCircleO;

IconFailCircleO.default = IconFailCircleO;
